import './lib/sass/spectre.scss';
import './lib/sass/sweetalert2.scss';
import './lib/sass/snipet.scss';
import './lib/sass/common.scss';

import App from './App.svelte';

const app = new App({
	target: document.getElementById('app'),
});

export default app;
